import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    const wasHidden = this.menuTarget.classList.contains("hidden")

    document.querySelectorAll("[data-kebab-menu-target='menu']").forEach(m => m.classList.add("hidden"))

    if (wasHidden) {
      this.menuTarget.classList.remove("hidden")
      this._outsideClick = (e) => {
        if (!this.element.contains(e.target)) this.close()
      }
      document.addEventListener("click", this._outsideClick)
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick)
      this._outsideClick = null
    }
  }

  disconnect() {
    if (this._outsideClick) {
      document.removeEventListener("click", this._outsideClick)
    }
  }
}
